import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    McfxViqCompanyUpdateInput,
    McfxViqCompanyUpdate as UpdateMcfxViqCompanyMutation,
    McfxViqCompanyUpdateVariables as UpdateMcfxViqCompanyMutationVariables,
} from 'nutshell-graphql-types';

import GET_UNLOCK_INFO from '../../../../people-iq/graphql/queries/get-unlock-info.graphql';

import UPDATE_MCFX_VIQ_COMPANY from '../mutations/update-mcfx-viq-company.graphql';

export function useUpdateMcfxViqCompany(): {
    updateMcfxViqCompany: (input: McfxViqCompanyUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [updateMcfxViqCompany, {loading, error}] = useMutation<
        UpdateMcfxViqCompanyMutation,
        UpdateMcfxViqCompanyMutationVariables
    >(UPDATE_MCFX_VIQ_COMPANY, {
        refetchQueries: [{query: GET_UNLOCK_INFO}],
    });

    return {
        updateMcfxViqCompany: (input: McfxViqCompanyUpdateInput) =>
            updateMcfxViqCompany({
                variables: {input},
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
